import { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import ApiService from '../../../../services/api';
import '../../css/editor.css';
import '../../css/teacher_list.css';
import { toast } from "react-toastify";
import User from '../../../../media/user.png';
import Add from '../../../../media/add.png';
import unlock from '../../../../media/eye1.png';
import lock from '../../../../media/eye2.png';
import AdminSelect from './admin_select';
import Back from '../../../../media/back.png';

const CreateUser = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [countries, setCountries] = useState([]);
  const [formData, setFormData] = useState({
      first_name: '',
      last_name: '',
      username: '',
      email: '',
      password:'',
      confirmPassword: '',
      nation: '',
      city: '',
      tax_id: '',
    });
  
  const [errors, setErrors] = useState({});

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);


   
  
    useEffect(() => {
      const fetchCountries = async () => {
        try {
          const res = await ApiService.getCountries();
          setCountries(res);
        } catch (err) {
          console.error('Errore:', err);
        } finally {
          setLoading(false);
        }
      };
  
      fetchCountries();
    }, []);
  
    const handleChange = e => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validate = () => {
      const errs = {};

      if (!formData.first_name.trim()) errs.first_name = ['Inserisci nome', true];
      if (!formData.last_name.trim()) errs.last_name = ['Inserisci cognome', true];
      if (!formData.username.trim()) errs.username = ['Inserisci username', true];
      if (!formData.email.trim()) errs.email = ['Inserisci indirizzo email', true];
      if (!formData.password) errs.password = ['Inserisci una password', true];
      if (!formData.confirmPassword) errs.confirmPassword = ['Inserisci la conferma della password', true];
      if (!formData.nation.trim()) errs.nation = ['Non hai effettuato nessuna scelta', true];
      if (!formData.city.trim()) errs.city =  ['Inserisci una località', true];
      if (!formData.tax_id.trim()) errs.tax_id = ['Inserisci il codice fiscale', true];

      return errs;
     };

    const getError = (field) => {
      if (!errors[field]) return null;

      return Array.isArray(errors[field])
        ? errors[field][0]
        : errors[field];
    };
  
    const handleSubmit = async e => {
      e.preventDefault();
        const errs = validate();
        if (Object.keys(errs).length > 0) {
          setErrors(errs);
          return;
        }
  
      try {
        setSaving(true);
        await ApiService.Registation(formData);
        toast.success('Creazione utente avvenuta con successo!');
        setFormData({
          first_name: '',
          last_name: '',
          username: '',
          email: '',
          password:'',
          confirmPassword: '',
          nation: '',
          city: '',
          tax_id:'',
        });
        navigate('/admin/utenti')
      } catch (err) {
          console.error(err);

          if (err.response && err.response.data) {
              setErrors(err.response.data);
          } else {
              toast.error('Errore durante la creazione');
          }
      }
      finally {
        setSaving(false);
      }
    };
    

  

  if (loading) {
      return ;
    }
   
  

  return (
    <form className="editor-form" onSubmit={handleSubmit}>

      <div className='account-container2'>
      
      <h2><img src={User} alt="crea utente" className="section-image" /> Crea utente</h2>

      <button
        className="tab-button"
        style={{marginTop:'20px'}}
        onClick={() => navigate(`/admin/utenti`)}
        type='button'
      >
        <img src={Back} alt="Modifica" className="button-image" style={{marginTop:'-2.5px', marginRight:'2.5px'}}/>
        Torna all'elenco degli utenti
      </button>

      <div  className="form-grid">

        <div className="form-group">
        <label>Nome *</label>
        <input
          type="text"
          name="first_name"
          value={formData.first_name}
          onChange={handleChange}
          className={`input ${errors.first_name ? "error" : ""}`}
          maxLength={250}
        />
        {getError('first_name') && (<span className="error">{getError('first_name')}</span>)}
       

        </div>

        <div className="form-group">
        <label>Cognome *</label>
        <input
          type="text"
          name="last_name"
          value={formData.last_name}
          onChange={handleChange}
          className={`input ${errors.last_name ? "error" : ""}`}
          maxLength={250}
        />
         {getError('last_name') && (
          <span className="error">
            {getError('last_name')}
          </span>
        )}
        
        </div>
        
        <div className="form-group">
        <label>Username *</label>
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
          className={`input ${errors.username ? "error" : ""}`}
          maxLength={150}
        />
        {getError('username') && (
          <span className="error">
            {getError('username')}
          </span>
        )}
       
        </div>

        <div className="form-group">
        <label>Indirizzo email *</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className={`input ${errors.email ? "error" : ""}`}
          maxLength={250}
        />
         {getError('email') && (
            <span className="error">
              {getError('email')}
            </span>
          )}
        
        </div>
        
        <div className="form-group">
          <label>Password *</label>

          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              className={`password-input2 ${errors.password ? "error" : ""}`}
              maxLength={128}
            />

            <button
              type="button"
              onClick={() => setShowPassword(prev => !prev)}
              className="toggle-password-btn"
              style={{background: 'transparent', boxShadow:'none', transform:'none', marginTop:'-20px'}}
            >
              <img
                src={showPassword ? lock : unlock}
                alt="toggle password"
                className="eye-icon"
              />
            </button>
          </div>
          {getError('password') && (<span className="error">{getError('password')}</span>)}
        </div>

          <div className="form-group">
            <label>Conferma Password *</label>

            <div className="password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={`password-input2 ${errors.confirmPassword ? "error" : ""}`}
                maxLength={128}
              />

              <button
                type="button"
                onClick={() => setShowConfirmPassword(prev => !prev)}
                className="toggle-password-btn"
                style={{background: 'transparent', boxShadow:'none', transform:'none', marginTop:'-20px'}}
              >
                <img
                  src={showConfirmPassword ? lock : unlock}
                  alt="toggle confirm password"
                  className="eye-icon"
                />
              </button>
            </div>
            {getError('confirmPassword') && (
              <span className="error">
                {getError('confirmPassword')}
              </span>
            )}
          </div>
        
        <div className="form-group">
        <label>Nazione *</label>
        <AdminSelect
          options={countries}
          value={countries.find(c => c.value === formData.nation) || null}
          onChange={(selected) =>
            setFormData(prev => ({
              ...prev,
              nation: selected?.value || ''
            }))
          }
          placeholder="Seleziona una nazione"
        />
          {getError('nation') && (
            <span className="error">
              {getError('nation')}
            </span>
          )}
       
        </div>

        <div className="form-group">
        <label>Città / Località *</label>
        <input
          type="text"
          name="city"
          value={formData.city}
          onChange={handleChange}
          className={`input ${errors.city ? "error" : ""}`}
          maxLength={250}
        />
         {getError('city') && (
            <span className="error">
              {getError('city')}
            </span>
          )}
        
        </div>

        <div className="form-group">
        <label>Codice Fiscale *</label>
        <input
          type="text"
          name="tax_id"
          value={formData.tax_id}
          onChange={handleChange}
          className={`input ${errors.tax_id ? "error" : ""}`}
          maxLength={16}
        />
        {getError('tax_id') && (
          <span className="error">
            {getError('tax_id')}
          </span>
        )}

        </div>
        
        
      </div>

      <button disabled={saving}  type='submit' style={{ marginTop: "50px" }}>
        <img src={Add} alt="Aggiungi" className="button-image2" />
         {saving ? 'Creazione in corso...' : 'Crea Utente'}
      </button>
      </div>
    </form>
  );
};

export default CreateUser;
